module.exports = "/_next/static/images/advance-success-5db11ebb095b614f5c63889af7ae7dd2.svg";